/**
 * Tabbed benefits section — tab panels and crossfading images.
 */
class PmdTabb extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;
    const tabs = this.querySelectorAll('.pmd-tb__tab');

    tabs.forEach((tab) => {
      tab.addEventListener(
        'click',
        () => {
          const idx = tab.getAttribute('data-tab');
          if (idx === null) return;

          this.#activateTab(idx);
        },
        { signal }
      );

      tab.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

          const tabsList = Array.from(tabs);
          const currentIndex = tabsList.indexOf(tab);
          if (currentIndex === -1) return;

          event.preventDefault();
          const dir = document.documentElement.dir === 'rtl' ? -1 : 1;
          const delta = event.key === 'ArrowRight' ? dir : -dir;
          const nextIndex = (currentIndex + delta + tabsList.length) % tabsList.length;
          const nextTab = tabsList[nextIndex];

          if (nextTab instanceof HTMLElement) {
            nextTab.focus();
            const nextIdx = nextTab.getAttribute('data-tab');
            if (nextIdx !== null) this.#activateTab(nextIdx);
          }
        },
        { signal }
      );
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /**
   * @param {string} idx
   */
  #activateTab(idx) {
    const tabs = this.querySelectorAll('.pmd-tb__tab');
    const panels = this.querySelectorAll('.pmd-tb__panel');
    const imgs = this.querySelectorAll('.pmd-tb__img');

    tabs.forEach((t) => {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    panels.forEach((p) => {
      p.classList.remove('is-active');
      p.setAttribute('hidden', '');
    });
    imgs.forEach((i) => {
      i.classList.remove('is-active');
      i.setAttribute('aria-hidden', 'true');
    });

    const activeTab = this.querySelector(`.pmd-tb__tab[data-tab="${idx}"]`);
    const panel = this.querySelector(`.pmd-tb__panel[data-panel="${idx}"]`);
    const img = this.querySelector(`.pmd-tb__img[data-img="${idx}"]`);

    if (activeTab) {
      activeTab.classList.add('is-active');
      activeTab.setAttribute('aria-selected', 'true');
    }
    if (panel) {
      panel.classList.add('is-active');
      panel.removeAttribute('hidden');
    }
    if (img) {
      img.classList.add('is-active');
      img.setAttribute('aria-hidden', 'false');
    }
  }
}

if (!customElements.get('pmd-tabb')) {
  customElements.define('pmd-tabb', PmdTabb);
}
